import React from 'react';

export const Version = () => <p>v{process.env.REACT_APP_VERSION}</p>;
